// import 'bootstrap/js/dist/util.js';
// import 'bootstrap/js/dist/tab.js';
import 'bootstrap/js/dist/dropdown.js';
import Tab from 'bootstrap/js/dist/tab.js';
import Modal from 'bootstrap/js/dist/modal.js';
import 'easyzoom/src/easyzoom.js';

import {i18n} from './utils.js';
import * as ShoppingCart from './modules/shoppingCart.js';
import './modules/quantity.js';
import './modules/print.js';

function enhanceAddToWishList() {
  const $forms = $('.form-addToWishList');

  $forms.submit(function (e) {
    ShoppingCart.addToWishList(e);
  });

  $('.js-wishListSelectList').on('click', (e) => {
    const $trigger = $(e.currentTarget);
    const $form = $trigger.closest('.form-addToWishList');

    $form.find('select').val($trigger.data('listid'));

    $form.submit();
  });

  $('.js-wishListCreateList').on('click', (e) => {
    const $trigger = $(e.currentTarget);
    const $addToWishListForm = $trigger.closest('.form-addToWishList');
    const modal = document.getElementById('wishList-create-dialog');
    const $modal = $(modal);
    const $createWishListForm = $modal.find('form');

    $createWishListForm.on('submit', (e) => {
      e.preventDefault();
    });

    $modal.on('shown.bs.modal', function () {
      $modal.find('#wishList-name')[0].focus();
    });

    // open modal
    const bsModal = Modal.getOrCreateInstance(modal);
    bsModal.show();
    // set click handler on modal
    $modal.on('click', (e) => {
      if (e.target.classList.contains('btn-primary')) {
        const url = $createWishListForm.attr('action');
        const data = $createWishListForm.serialize();

        $.ajax({
          type: 'POST',
          url: `${url}?format=json`,
          data: data,
          success: (data) => {
            bsModal.hide();

            const responseJSON = JSON.parse(data);

            // element can be input[type="hidden"] or select depending on number of wishLists present
            $addToWishListForm.find('[name="id"]').remove();
            $addToWishListForm.prepend(
              `<input type="hidden" name="id" value="${responseJSON.id}" id="id">`,
            );

            $addToWishListForm.submit();
          },
          error: (response) => {
            $createWishListForm.find('.modal-body')
              .html(`<div class="alert alert-danger">
              ${i18n('wishList.create.error')}
            </div>`);
          },
        });
        return true;
      }

      return false;
    });
  });

  $('.js-wishListCreateDefault').on('click', (e) => {
    const $trigger = $(e.currentTarget);
    const $addToWishListForm = $trigger.closest('.form-addToWishList');
    const modal = document.getElementById('wishList-create-dialog');
    const $modal = $(modal);
    const $createWishListForm = $modal.find('form');

    const url = $createWishListForm.attr('action');
    const data = $createWishListForm.serialize();

    $.ajax({
      type: 'POST',
      url: `${url}?format=json`,
      data: data,
      success: (data) => {
        const responseJSON = JSON.parse(data);

        $addToWishListForm.find('[name="id"]').remove();
        $addToWishListForm.prepend(
          `<input type="hidden" name="id" value="${responseJSON.id}" id="id">`,
        );

        $addToWishListForm.submit();
      },
      error: (response) => {
        // open modal
        Modal.getOrCreateInstance(modal).show();

        $createWishListForm.find('.modal-body')
          .html(`<div class="alert alert-danger">
          ${i18n('wishList.create.error')}
        </div>`);
      },
    });
    return true;
  });

  // $('[data-bs-toggle="dropdown"]').on('click', (e) => {
  //   $('[aria-labelledBy="' + $(e.currentTarget).attr('id') + '"]').toggleClass('show')
  // });
}

(function ($) {
  // Zoom setup
  const $zoom = $('.easyzoom');
  $zoom.easyZoom();

  const viewport = window
      .getComputedStyle(document.body, ':after')
      .getPropertyValue('content'),
    zoomApi = $zoom.data('easyZoom');

  if (viewport.indexOf('xs') != -1 || viewport.indexOf('sm') != -1) {
    // initially deactive zoom to avoid
    // accidental activation during page scroll
    zoomApi.teardown();

    const $toggle = $(
      `<button class="easyzoom-toggle btn btn-link" data-active="false">[${i18n('zoom.activate')}]</button>`,
    );
    $zoom.after($toggle);

    $toggle.on('click', (e) => {
      e.preventDefault();

      if ($toggle.data('active') === true) {
        $toggle.text(`[${i18n('zoom.activate')}]`).data('active', false);
        zoomApi.teardown();
      } else {
        $toggle.text(`[${i18n('zoom.deactivate')}]`).data('active', true);
        zoomApi._init();
      }

      return false;
    });
  }

  // Thumbnail interaction
  const $thumbnails = $('.thumbnails'),
    $tnItems = $('.thumbnails-item'),
    $detailImg = $('#detail_img');

  $tnItems.on('click', (e) => {
    e.preventDefault();

    const $tar = $(e.currentTarget),
      $tarLink = $tar.find('a'),
      tarImg = $tar.find('img').attr('src');

    $tar.addClass('active').siblings().removeClass('active');

    zoomApi.swap($tarLink.data('standard'), $tarLink.attr('href'));
  });

  // Buy box / Cart interaction
  ShoppingCart.init();

  $('.form-addToCart').submit(function (e) {
    ShoppingCart.add(e);
  });

  enhanceAddToWishList();

  $('.sku-list .js-quantity').quantity();

  // Tab interaction
  $('#product-tabs .nav-link').on('click', function (e) {
    e.preventDefault();
    new Tab(this).show();
  });
})(jQuery);



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/product.js